import { raviApisClient } from '@/common/apis/client';
import { useQuery } from '@tanstack/react-query';
import getConfig from 'next/config';

export interface AbsentScoreResponse {
  list: Array<{
    Id: number;
    Title: string | null;
    CreatedAt: string | null;
    UpdatedAt: string;
    slug: string;
    penalty_score: number;
    absent_count?: number;
  }>;
  pageInfo: {
    totalRows: number;
    page: number;
    pageSize: number;
    isFirstPage: boolean;
    isLastPage: boolean;
  };
}

export const officeAbsentScorePath = (slug: string) =>
  `/ravi/v1/office-absent-score/doctors/${encodeURIComponent(slug)}`;

export const onlineVisitAbsentScorePath = (slug: string) =>
  `/ravi/v1/online-visit-absent-score/doctors/${encodeURIComponent(slug)}`;

export const raviApisPublicOrigin = () => {
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    return `${window.location.origin}/__dev-proxy/ravi-apis`;
  }
  try {
    const { publicRuntimeConfig } = getConfig() || {};
    if (publicRuntimeConfig?.RAVI_APIS_BASE_URL) return publicRuntimeConfig.RAVI_APIS_BASE_URL;
  } catch {
    // Storybook / tests without Next config
  }
  return 'https://ravi-apis.paziresh24.com';
};

export const onlineVisitAbsentScoreUrl = (slug: string) =>
  `${raviApisPublicOrigin()}${onlineVisitAbsentScorePath(slug)}`;

export const getAbsentScore = async (slug: string): Promise<AbsentScoreResponse> => {
  const { data } = await raviApisClient.get<AbsentScoreResponse>(officeAbsentScorePath(slug));
  return data;
};

export const useAbsentScore = (slug: string | undefined, enabled: boolean = true) => {
  return useQuery<AbsentScoreResponse>(
    ['absentScore', slug],
    () => getAbsentScore(slug!),
    {
      enabled: enabled && !!slug,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 2,
    }
  );
};
